import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import { useUsersMeQuery } from 'src/Redux/userInfoApi'
import { getIsAuth } from 'src/Redux/auth-process/credentialsSlice/selectors'
import { clearUserState } from 'src/Redux/auth-process/userSlice'
import { removeCookiesHandler } from 'src/Constants/functions'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { useLogOut } from 'src/Hooks/useLogOut'
import { ErrorCode } from 'src/Redux/types'

export const useInitApiCalls = (): null => {
  const dispatch = useAppDispatch()
  const isAuth = useAppSelector(getIsAuth)
  const { setSearch } = useCustomSearchParams()
  const { handleLogOut } = useLogOut()
  const { error } = useUsersMeQuery(void 0, { skip: !isAuth })

  const isUnauthorized =
    isAuth &&
    typeof error === 'object' &&
    'status' in error &&
    error.status === ErrorCode.Unauthorized

  useEffect(() => {
    if (isUnauthorized) {
      handleLogOut()
      dispatch(clearUserState())
      setSearch({})
      removeCookiesHandler()
    }
    // don't add setSearch to dependencies it call rerender
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUnauthorized, dispatch])

  return null
}
